import axios from './api.request'



export const getData = (lang) => {
  return axios.request({
      url: '/c?cid=35&ctype=game_web&lang=' + lang,
      method: 'get'
  })
}

export const getKol = (info) => {
  return axios.request({
    url: '/m/video/kolList',
    data: info,
    method: 'post'
  })
}


